import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import _ from 'lodash';
import {
  IS_LOADING,
  COMPANIES_DATA
} from './types';

export const getCompanies = codes => async dispatch => {
  let url = 'companies';
  if (codes) {
    url += `?code=${codes}`;
  }

  dispatch({ type: IS_LOADING, status: true, names: { COMPANIES_DATA: true } });
  await axios.get(url).then(response => {
    const data = (response.data && response.data.data) || response.data || [];
    dispatch({ type: COMPANIES_DATA, playload: { data } });
    dispatch({ type: IS_LOADING, status: false, names: { COMPANIES_DATA: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: IS_LOADING, status: false, names: { COMPANIES_DATA: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};
